import { colors } from '@lmc/common/constants'
import { Text } from '@lmc/ui-kit'
import PropTypes from 'prop-types'
import type React from 'react'

interface CarePlanSectionHeaderProps {
  title: string
}

const CarePlanSectionHeader: React.FC<CarePlanSectionHeaderProps> = ({
  title
}) => (
  <div>
    <Text as="h4" style={styles.title}>
      {title}
    </Text>
  </div>
)

const styles = {
  title: { color: colors.black, opacity: 0.7 }
}

CarePlanSectionHeader.propTypes = {
  title: PropTypes.string.isRequired
}

export default CarePlanSectionHeader
